<div class="title-container">Remaining Budget vs Order Amount
    <div class="rbpo-container">
        <div class="rbpo-left">
            <div class="rbpo-values-row">
                <div class="rbpo-value-block">
                    <div class="rbpo-color-bar rbpo-po"></div>
                    <div class="rbpo-value">{{formattedPurchaseOrder}}</div>
                    <div class="rbpo-label">Order Amount</div>
                </div>
                <div class="rbpo-value-block">
                    <div class="rbpo-color-bar rbpo-budget"></div>
                    <div class="rbpo-value">{{formattedRemainingBudget}}</div>
                    <div class="rbpo-label">Remaining Budget</div>
                </div>
            </div>
        </div>
        <div class="rbpo-chart-wrapper">
            <p-chart type="doughnut" [data]="data" [options]="options" class="rbpo-chart"></p-chart>
            <div class="rbpo-chart-center">
                <span class="rbpo-total">{{formattedTotal}}</span>
                <span class="rbpo-total-label">Total</span>
            </div>
        </div>
    </div>
</div>